import React from "react";
import { ClassifiedType } from "../../../types/main-types/mainTypes";
import noImageAvailable from "../../../assets/images/no_image_available.png";
import TrustedMemberBadge from "../../common/trsuted-member-badge/TrustedMemberBadge";
import { formatEpochTime } from "../../../utils/timeConvertors";
import { FaMapMarkerAlt, FaTachometerAlt } from "react-icons/fa";
import { MdSpeed } from "react-icons/md";
import "./ad-card.css";

interface AdCardProps {
  adDetails: ClassifiedType;
  isBoosted?: boolean;
}

function AdCard({ adDetails, isBoosted }: AdCardProps) {
  const imgUrl =
    adDetails?.image_urls?.length > 0
      ? adDetails.image_urls[0]
      : noImageAvailable;

  return (
    <div className="listing-card">
      {/* Image */}
      <div className="listing-card__image-panel">
        <div
          className="listing-card__img"
          style={{ backgroundImage: `url("${imgUrl}")` }}
        />
      </div>

      {/* Body */}
      <div className="listing-card__body">
        {/* Title */}
        <h5 className="listing-card__title">
          {adDetails?.model} {adDetails?.make} {adDetails?.year}
        </h5>

        {/* Price */}
        {adDetails?.price ? (
          <div className="listing-card__price">
            Rs {adDetails.price.toLocaleString()}
          </div>
        ) : (
          <div className="listing-card__price-empty" />
        )}

        {/* Meta: mileage + location */}
        <div className="listing-card__meta">
          {adDetails?.mileage ? (
            <span className="listing-card__meta-item">
              <MdSpeed size={14} />
              {adDetails.mileage.toLocaleString()} km
            </span>
          ) : null}
          {adDetails?.location ? (
            <span className="listing-card__meta-item">
              <FaMapMarkerAlt size={12} />
              {adDetails.location}
            </span>
          ) : null}
        </div>

        {/* Footer: date + badges */}
        <div className="listing-card__footer">
          <span className="listing-card__date">
            {formatEpochTime(Number(adDetails?.time))}
          </span>
          <div className="listing-card__badges">
            {isBoosted && (
              <span className="badge-boosted">⚡ Boosted</span>
            )}
            {adDetails?.seller_profile?.verified && <TrustedMemberBadge />}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdCard;
